import {
  useEffect,
  useState
} from "react";

import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaPalette
} from "react-icons/fa";

import MainLayout from "../../components/layout/MainLayout";

import {
  getDesigns,
  createDesign,
  updateDesign,
  deleteDesign
} from "../../api/designApi";

const Designs = () => {

  const [designs, setDesigns] =
    useState([]);

  const [showModal, setShowModal] =
    useState(false);

  const [editingId, setEditingId] =
    useState(null);

  const [form, setForm] =
    useState({

      design_code: "",
      design_name: "",
      description: "",
      status: "active"

    });

  useEffect(() => {

    loadDesigns();

  }, []);

  const loadDesigns =
    async () => {

      try {

        const res =
          await getDesigns();

        setDesigns(
          res.data.data || []
        );

      }
      catch (error) {

        console.log(error);

      }

    };

  const resetForm = () => {

    setEditingId(null);

    setForm({

      design_code: "",
      design_name: "",
      description: "",
      status: "active"

    });

  };

  const saveDesign =
    async (e) => {

      e.preventDefault();

      try {

        if (editingId) {

          await updateDesign(
            editingId,
            form
          );

        } else {

          await createDesign(
            form
          );

        }

        loadDesigns();

        setShowModal(false);

        resetForm();

      }
      catch (error) {

        console.log(error);

      }

    };

  const editDesign =
    (design) => {

      setEditingId(
        design.id
      );

      setForm(design);

      setShowModal(true);

    };

  const removeDesign =
    async (id) => {

      if (
        !window.confirm(
          "Delete Design?"
        )
      ) return;

      await deleteDesign(id);

      loadDesigns();

    };

  return (

    <MainLayout>

      <div className="card shadow-sm border-0">

        <div className="card-header bg-white d-flex justify-content-between align-items-center">

          <div>

            <h5 className="mb-0">
              Design Master
            </h5>

            <small className="text-muted">
              Manage Product Designs
            </small>

          </div>

          <button
            className="btn btn-primary"
            onClick={() =>
              setShowModal(true)
            }
          >

            <FaPlus />
            {" "}
            Add Design

          </button>

        </div>

        <div className="card-body">

          <table className="table table-hover align-middle">

            <thead>

              <tr>

                <th>Code</th>
                <th>Design Name</th>
                <th>Description</th>
                <th>Status</th>
                <th width="120">
                  Action
                </th>

              </tr>

            </thead>

            <tbody>

              {
                designs.length > 0
                ?

                designs.map(
                  (item) => (

                    <tr key={item.id}>

                      <td>
                        {item.design_code}
                      </td>

                      <td>

                        <FaPalette
                          className="me-2 text-primary"
                        />

                        {item.design_name}

                      </td>

                      <td>
                        {item.description}
                      </td>

                      <td>

                        <span
                          className={
                            item.status === "active"
                            ?
                            "badge bg-success"
                            :
                            "badge bg-danger"
                          }
                        >

                          {item.status}

                        </span>

                      </td>

                      <td>

                        <button
                          className="btn btn-warning btn-sm me-2"
                          onClick={() =>
                            editDesign(item)
                          }
                        >

                          <FaEdit />

                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() =>
                            removeDesign(item.id)
                          }
                        >

                          <FaTrash />

                        </button>

                      </td>

                    </tr>

                  )
                )

                :

                <tr>

                  <td
                    colSpan="5"
                    className="text-center"
                  >

                    No Designs Found

                  </td>

                </tr>

              }

            </tbody>

          </table>

        </div>

      </div>

      {
        showModal && (

          <div
            className="modal d-block"
            style={{
              background:
                "rgba(0,0,0,.5)"
            }}
          >

            <div className="modal-dialog">

              <div className="modal-content">

                <form
                  onSubmit={saveDesign}
                >

                  <div className="modal-header">

                    <h5>

                      {
                        editingId
                        ?
                        "Edit Design"
                        :
                        "Add Design"
                      }

                    </h5>

                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {

                        setShowModal(false);

                        resetForm();

                      }}
                    />

                  </div>

                  <div className="modal-body">

                    <input
                      className="form-control mb-3"
                      placeholder="Design Code"
                      value={
                        form.design_code
                      }
                      onChange={(e)=>
                        setForm({
                          ...form,
                          design_code:
                          e.target.value
                        })
                      }
                    />

                    <input
                      className="form-control mb-3"
                      placeholder="Design Name"
                      value={
                        form.design_name
                      }
                      onChange={(e)=>
                        setForm({
                          ...form,
                          design_name:
                          e.target.value
                        })
                      }
                    />

                    <textarea
                      className="form-control mb-3"
                      rows="3"
                      placeholder="Description"
                      value={
                        form.description
                      }
                      onChange={(e)=>
                        setForm({
                          ...form,
                          description:
                          e.target.value
                        })
                      }
                    />

                    <select
                      className="form-select"
                      value={
                        form.status
                      }
                      onChange={(e)=>
                        setForm({
                          ...form,
                          status:
                          e.target.value
                        })
                      }
                    >

                      <option value="active">
                        Active
                      </option>

                      <option value="inactive">
                        Inactive
                      </option>

                    </select>

                  </div>

                  <div className="modal-footer">

                    <button
                      type="submit"
                      className="btn btn-primary"
                    >

                      Save Design

                    </button>

                  </div>

                </form>

              </div>

            </div>

          </div>

        )
      }

    </MainLayout>

  );

};

export default Designs;